<template>
  <!-- <a-spin :spinning="state.spinning"> -->
  <section class="flex w-full flex-col flex-1 remote-table">
    <a-row
      :gutter="24"
      class="mb10 aic"
      style="margin-left: 0; margin-right: 0"
    >
      <div
        class="dib fs12"
        v-if="props.showSelection && state.selectedRowKeys.length"
      >
        已选择
        <span class="color-1989fa">{{ state.selectedRowKeys.length }}</span
        >条数据
        <a-button type="link" size="small" @click="onCancelSelect">
          取消选择
        </a-button>
      </div>
      <a-col flex="1">
        <slot name="btns"> </slot>
      </a-col>

      <a-button
        size="small"
        class="mr10"
        plain
        :loading="exportLoading"
        v-if="props.hasExport"
        @click="exportExcel"
      >
        <template #icon>
          <DownloadOutlined />
        </template>
        导出</a-button
      >
      <a-button
        size="small"
        class="mr10"
        v-if="props.hasRefresh"
        @click="refresh()"
      >
        <template #icon>
          <SyncOutlined style="transform: translateY(-3px);" />
        </template>
        刷新</a-button
      >
      <a-button
        v-if="props.hasReset"
        size="small"
        class="mr10"
        @click="reset()"
      >
        <template #icon>
          <SyncOutlined style="transform: translateY(-3px);" />
        </template>
        重置
      </a-button>
      <column-settings
        v-if="props.showSetting && !props.columns"
        class="show-setting"
        :buttonStyle="props.buttonStyle"
        v-model:value="state.menuListFields"
        :menuName="props.menuName"
        @change="refreshColumn"
      ></column-settings>
    </a-row>
    <div class="vxe-table-container flex-1" ref="tableContainerRef">
      <a-table
        v-if="state.tableColumns?.length"
        v-drag-width="{ columns: state.tableColumns, id: state.tableId }"
        bordered
        :uid="state.uid"
        :loading="state.spinning"
        size="small"
        ref="tableDom"
        :columns="state.tableColumns"
        :data-source="state.tableDatas"
        :pagination="false"
        @change="changeTable"
        class="myRemoteTable"
        :class="{
          tableEmpty: state.tableDatas.length === 0
        }"
        :scroll="{
          x: x || '100%',
          y: isCalcTableHeight || isAddBaseTableHeight ? state.yy : scrollY
        }"
        :row-selection="myRowSelection"
        :row-key="props.rowKey"
      >
        <!-- 自定义过滤器 -->
        <template #customFilterDropdown="{ confirm, clearFilters, column }">
          <!-- 批量搜索 -->
          <template v-if="column.isBatch">
            <div class="rm-popover pr p10">
              <h4 class="mb10">批量查询</h4>
              <a-input
                style="width: 100%"
                allowClear
                v-model:value="column.batchValue"
                placeholder="支持复制或输入关键词"
                @pressEnter="e => handlerBatchBlur(e, column)"
                @blur="e => handlerBatchBlur(e, column)"
              />
              <a-tag
                style="float: left"
                closable
                @close="handlerDelBatchItem(tIndex, column)"
                class="mb10"
                v-for="(t, tIndex) in column.batchTags"
                :key="t"
              >
                {{ t }}</a-tag
              >
            </div>
            <a-row class="action-wrap p10 df jcfe">
              <a-button
                size="small"
                class="mr10"
                @click="() => (column.isBatch = false)"
              >
                切换普通查询
              </a-button>
              <a-button
                size="small"
                class="mr10"
                type="primary"
                ghost
                @click="
                  () => {
                    column.batchTags = []
                    handleBatchSearch(confirm, column, true, columnIndex)
                  }
                "
              >
                重置
              </a-button>
              <a-button
                size="small"
                type="primary"
                @click="
                  () => {
                    handleBatchSearch(confirm, column, true)
                  }
                "
              >
                确定
              </a-button>
            </a-row>
          </template>
          <!-- 单个 搜索所 -->
          <template v-else>
            <div class="sort-wrap df jcsb p10">
              <div>
                <span
                  class="cp mr30"
                  :style="{
                    color: column.desc === 'asc' ? '#1989fa' : ''
                  }"
                  @click="handleSort('asc', column, confirm)"
                >
                  <SortAscendingOutlined />
                  <span class="fs12">升序</span>
                </span>
                <span
                  class="cp"
                  :style="{
                    color: column.desc === 'desc' ? '#1989fa' : ''
                  }"
                  @click="handleSort('desc', column, confirm)"
                >
                  <SortDescendingOutlined />
                  <span class="fs12">降序 </span>
                </span>
              </div>
              <div>
                <a-checkbox
                  v-if="column.needEmpty"
                  :key="column.isBlank"
                  :checked="column.isBlank"
                  @change="e => setBlank(e, column)"
                >
                  空
                </a-checkbox>
                <DiffOutlined
                  class="ml10"
                  :style="{
                    color: column.batchTags?.length > 0 ? '#1989fa' : ''
                  }"
                  v-if="column.isBatchQuery == 1"
                  @click="() => (column.isBatch = true)"
                  style="font-size: 20px"
                />
              </div>
            </div>
            <!-- 时间范围选择 -->
            <div v-if="column.model === 1" class="date-wrap mb10 pr10 pl10">
              <a-range-picker
                v-model:value="column.filterValue"
                style="width: 300px"
                format="YYYY-MM-DD"
                allowClear
                value-format="YYYY-MM-DD"
              />
            </div>
            <!-- 数字范围 model 7-->
            <div
              v-else-if="column.model === 7"
              class="number-wrap mb10 pr10 pl10 df aic jcc"
              style="width: 250px"
            >
              <a-input-number
                :min="0"
                placeholder="最小值"
                :precision="0"
                allowClear
                v-model:value="column.filterValue[0]"
                class="mr10 f1"
              />
              ~
              <a-input-number
                :min="column.filterValue[0] || 0"
                :precision="0"
                allowClear
                placeholder="最大值"
                v-model:value="column.filterValue[1]"
                class="ml10 f1"
              />
            </div>
            <div
              class="cascader-tree mb-10px px-10px"
              v-else-if="column.model === 12"
              style="width: 300px"
            >
              <a-tree-select
                treeNodeFilterProp="title"
                placeholder="请选择"
                class="w-full"
                allowClear
                tree-checkable
                show-search
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :replaceFields="{
                  children: 'children',
                  title: 'label',
                  key: 'value'
                }"
                :tree-data="column.plainOptions"
                v-model:value="column.filterValue"
              >
              </a-tree-select>
            </div>

            <div
              v-else
              class="search-wrap pr10 pl10"
              style="border-bottom: 1px solid #eaeaea; max-width: 300px"
            >
              <!-- 远程搜索 -->
              <a-input-search
                v-if="column.model === 2"
                :placeholder="`搜索 ${column?.customeTitle}`"
                :loading="state.loading"
                v-model:value="column.params.queryStr"
                @change="e => remoteSearch(e, column)"
              />
              <a-input
                v-else
                v-model:value="column.searchValue"
                :placeholder="`搜索 ${column?.customeTitle}`"
                @change="e => inputSearch(e, column)"
                @pressEnter="() => handleSearch(confirm, column)"
              />
              <div class="checkbox-wrap">
                <a-spin :spinning="state.loading">
                  <a-checkbox
                    :key="column.checkAll"
                    :checked="column.checkAll"
                    :indeterminate="column.indeterminate"
                    @change="e => onCheckAllChange(e, column)"
                  >
                    全选
                  </a-checkbox>
                  <span v-if="column.plainOptions"
                    >({{ column.filterValue ? column.filterValue.length : 0 }}/
                    {{
                      column.plainOptions && column.plainOptions.length
                    }})</span
                  >
                  <a-divider
                    dashed
                    style="margin-top: 10px; margin-bottom: 10px"
                  />
                  <a-checkbox-group
                    v-model:value="column.filterValue"
                    @change="values => onChange(values, column)"
                  >
                    <div v-for="c in column.plainOptions" :key="c.value">
                      <a-checkbox :value="c.key" :label="c.key">
                        {{ c.value || '空' }}
                      </a-checkbox>
                    </div>
                  </a-checkbox-group>
                </a-spin>
              </div>
            </div>

            <div class="action-wrap p10 df jcfe">
              <a-button
                type="primary"
                size="small"
                style="width: 90px; margin-right: 8px"
                @click="() => handleSearch(confirm, column)"
              >
                <template #icon>
                  <SearchOutlined />
                </template>
                搜索
              </a-button>
              <a-button
                size="small"
                style="width: 90px"
                @click="() => handleReset(confirm, column, clearFilters)"
              >
                重置
              </a-button>
            </div>
          </template>
        </template>
        <!-- 透传所有具名插槽 -->
        <template #headerCell="{ column }">
          <template v-if="column.customeTitle">
            <span v-if="column.notes">
              {{ column.customeTitle }}
              <a-tooltip>
                <template #title>{{ column.notes }}</template>
                <QuestionCircleOutlined />
              </a-tooltip>
            </span>
            <span v-else>
              {{ column.customeTitle }}
            </span>
          </template>
          <span v-else>
            {{ column.title }}
          </span>
        </template>
        <!-- bodyCell -->
        <template #bodyCell="{ column, record, text, index }">
          <template v-if="$slots[column.key]">
            <slot
              :name="column.key"
              :record="record"
              :text="text"
              :index="index"
            />
          </template>
          <span v-else>{{ record[column.key] }}</span>
        </template>
        <template #footer v-if="hasFooter">
          <slot name="footer"></slot>
        </template>
      </a-table>
    </div>
    <div
      ref="pagination"
      v-if="props.hasPaginate"
      class="df jcsb h-40px items-center px-10px"
      style="padding-bottom: 0"
    >
      <div class="o06">
        {{
          `共 ${state.total || 0}条数据，第${state.pageNum}/${Math.ceil(
            (state.total || 0) / state.pageSize
          )}页`
        }}
      </div>
      <div>
        <a-pagination
          size="small"
          :page-size="state.pageSize"
          v-model:current="state.pageNum"
          :total="state.total"
          @change="changePage"
          @showSizeChange="changePage"
          :pageSizeOptions="['20', '50', '100', '150', '200', '500']"
          show-size-changer
          show-quick-jumper
        />
      </div>
    </div>
  </section>
  <!-- </a-spin> -->
</template>
<script setup>
import {
  reactive,
  watch,
  onMounted,
  computed,
  ref,
  nextTick,
  defineExpose
} from 'vue'
import ColumnSettings from './ColumnSettings.vue'
import { config_list_menu_field_post_ } from 'server/apis/4802.js'
import { debounce, cloneDeep } from 'lodash-es'
import { observeDomResize } from 'utils/utils.js'
import {
  SearchOutlined,
  SortAscendingOutlined,
  SortDescendingOutlined,
  DiffOutlined,
  QuestionCircleOutlined,
  SyncOutlined,
  DownloadOutlined
} from '@ant-design/icons-vue'
import {
  executeServer,
  getConfigColumn,
  getCascaderTree,
  executeSearch,
  useColumnWidth,
  useInitState
} from './remoteTable.js'
// import dragWidth from 'cupshe-dragWidth'
// const vDragWidth = dragWidth
const props = defineProps({
  value: {
    type: Array
  },
  // 获取列接口的菜单名称
  menuName: {
    type: String
  },
  tableId: {
    type: String
  },
  // 是否支持多选
  showSelection: {
    type: Boolean,
    default: true
  },
  interfaceURL: {
    type: String,
    default: ''
  },
  // 是否显示列设置
  showSetting: {
    type: Boolean,
    default: false
  },
  hasExport: {
    type: Boolean,
    default: false
  },
  hasReset: {
    type: Boolean,
    default: true
  },
  hasRefresh: {
    type: Boolean,
    default: true
  },
  // 表格是否显示分页
  hasPaginate: {
    type: Boolean,
    default: true
  },
  // 是否显示操作项目
  hasAction: {
    type: Boolean,
    default: false
  },
  //是否显示底部
  hasFooter: {
    type: Boolean,
    default: false
  },
  // 是否立即查询数据，若为false，则手动调refresh或reset
  immediate: {
    type: Boolean,
    default: true
  },
  // 列设置的按钮样式
  buttonStyle: {
    type: Object,
    default: () => {
      return {}
    }
  },
  // 列宽设置
  columnWidth: {
    type: Object,
    default: () => {
      return {}
    }
  },
  columnFixed: {
    type: Object,
    default: () => {
      return {}
    }
  },
  y: {
    type: [String, Number],
    default: 770
  },
  sy: {
    type: [String, Number],
    default: 590
  },
  x: {
    type: [String, Number],
    default: 0
  },
  // 拉取table数据的接口参数
  apiParams: {
    type: Object,
    default: () => {
      return {}
    }
  },
  // 场景： 网址带搜索条件，打开网站后默认进行过滤搜索
  queryParams: {
    type: Object,
    default: () => {
      return {}
    }
  },
  columns: {
    type: Array,
    default: null
  },
  rowKey: {
    type: Function,
    default: r => r.id
  },
  // 使用场景，以某个字段的值为条件，查询满足这个条件下的所有筛选项
  // 列设置的参数
  queryFields: {
    type: Array,
    default: () => {
      return []
    }
  },
  pageSize: {
    type: Number,
    default: 50
  },
  rowType: {
    type: String,
    default: 'checkbox'
  },
  selectRowKeys: {
    type: Array,
    default: () => {
      return null
    }
  },
  // 发送请求前function
  beforeReqLoad: {
    type: Function,
    default: null
  },
  // 接口响应后function
  afterRespLoad: {
    type: Function,
    default: null
  },
  getCheckboxProps: {
    type: Function,
    default: null
  },
  canChangeColumnWidth: {
    type: Boolean,
    default: true
  },
  method: {
    type: String,
    default: 'post'
  },
  // 表格高度是否自动计算
  isCalcTableHeight: {
    type: Boolean,
    default: false
  },
  // 是否给表格增加默认值
  isAddBaseTableHeight: {
    type: Boolean,
    default: false
  },
  filterStorage: {
    type: Boolean,
    default: false
  },
  // 是否监听apiParams变了后查询接口
  isWatchApiParams: {
    type: Boolean,
    default: true
  }
})
const emits = defineEmits(['update:value', 'change', 'select', 'export'])

const tableDom = ref(null)
const tableContainerRef = ref(null)
const exportLoading = ref(false)

const state = reactive({
  method: props.method,
  beforeReqLoad: props.beforeReqLoad,
  interfaceURL: props.interfaceURL,
  hasPaginate: props.hasPaginate,
  columnWidth: props.columnWidth || {},
  tableId: props.tableId || props.menuName || 'remoteTable',
  tableDatas: [],
  options: [],
  tableColumns: [],
  query: {
    sortList: [],
    ...props.queryParams
  },
  uid: 0,
  loading: false,
  pageNum: 1,
  pageSize: props.pageSize,
  spinning: false,
  total: 0,
  localApiParams: props.apiParams
    ? JSON.parse(JSON.stringify(props.apiParams))
    : {},
  menuListFields: [],
  selectedRowKeys: props.selectRowKeys || [],
  selectedRows: [],
  currentPageRowKeys: {},
  pageRows: {},
  mql: window.matchMedia('(max-width: 1400px)'),
  yy: true
})
watch(
  () => state.tableColumns,
  val => {
    console.log(val, 'tableColumns')
  },
  {
    immediate: true,
    deep: true
  }
)
/**
 * 创建列
 */
state.createColumns = datas => {
  state.tableColumns = cloneDeep(datas)
  state.tableColumns.forEach(column => {
    column.filtered = !!column.filterValue?.length
    column.width = useColumnWidth(column, state)
    if (column?.customFilterDropdown) {
      column.onFilterDropdownOpenChange = visible => {
        onFilterDropdownOpenChange(visible, column)
      }
    }
  })
}

// 列筛选
const onFilterDropdownOpenChange = (visible, column) => {
  if (visible) {
    nextTick(() => {
      column.filtered = true
      column.isBatch = false
    })

    if (props.queryFields?.length) {
      column.params.queryFields = props.queryFields
    }
    if (+column.model === 12) {
      getCascaderTree(column, state)
    } else if (![1].includes(column.model)) {
      getConfigColumn(column, state)
    }
  }
  nextTick(() => {
    column.filtered =
      !!column.filterValue.length ||
      !!column.batchTags?.length ||
      column.desc ||
      column.isBlank
  })
}
// 全选
const onCheckAllChange = (e, column) => {
  column.checkAll = e.target.checked
  column.indeterminate = false
  column.filterValue = e.target.checked
    ? column.plainOptions.map(e => e.key)
    : []
}
// 设置筛选空数据
const setBlank = (e, column) => {
  column.isBlank = e.target.checked
}
// 输入框本地模糊匹配搜索
const inputSearch = debounce(function(e, column) {
  if (e.target.value) {
    column.plainOptions = state.options.filter(
      _ =>
        _.value &&
        _.value.toLowerCase().includes(e.target.value.trim().toLowerCase())
    )
  } else {
    column.plainOptions = state.options
  }
}, 300)
// 远程搜索
const remoteSearch = debounce(function(e, column) {
  state.loading = true
  column.params.queryStr = e.target.value ? e.target.value.trim() : ''
  getConfigColumn(column, state)
}, 300)

const onChange = (checkedList, column) => {
  column.checkAll = checkedList.length === column.plainOptions.length
  column.indeterminate =
    !!checkedList.length && checkedList.length < column.plainOptions.length
}
// 点击搜索
const handleSearch = (comfirm, column) => {
  state.pageNum = 1
  column.isBatch = false
  column.filtered = !!column.filterValue.length
  comfirm()
  executeSearch(state, props)
}
// 列筛选重置
const handleReset = (comfirm, column) => {
  state.pageNum = 1
  resetColumnFilter(column)
  comfirm()
  executeSearch(state, props)
}
// 排序
const handleSort = (sort, column, comfirm) => {
  column.desc = sort
  comfirm && comfirm()
  executeSearch(state, props)
  console.log(column)
}
const changeTable = (pag, filters, sorter) => {
  const obj = {
    ascend: 'asc',
    descend: 'desc'
  }
  if (sorter) {
    handleSort(
      sorter.order ? obj[sorter.order] : '',
      state.tableColumns.findIndex(column => column.key === sorter.columnKey)
    )
  }
  console.log(pag, filters, sorter)
}
// 批量查询输入失去焦点
const handlerBatchBlur = (e, column) => {
  const batchTags = column.batchTags
  if (!batchTags) {
    column.batchTags = []
  }
  const valueStr = e.target.value.replaceAll(/\t|\n|\s+/g, ' ')
  const values = valueStr.split(' ').filter(column => {
    return column.trim() !== ''
  })
  column.batchTags = [...new Set(column.batchTags.concat(values))]
  column.batchValue = null
}
// 删除输入记录
const handlerDelBatchItem = (index, column) => {
  column.batchTags.splice(index, 1)
}
const handleBatchSearch = (comfirm, column, isBatch, index) => {
  state.pageNum = 1
  column.filtered = !!column.batchTags?.length
  if (index >= 0) {
    resetColumnFilter(column)
  }

  column.isBatch = isBatch
  comfirm()
  executeSearch(state, props)
}
// 分页
const changePage = (page, size) => {
  state.pageNum = page
  state.pageSize = size
  executeServer(state, props)
}
// 重置全部清空
const reset = apiParams => {
  if (
    apiParams &&
    Object.prototype.toString.call(apiParams) === '[object Object]'
  ) {
    state.localApiParams = apiParams
  }
  state.pageNum = 1
  state.pageSize = props.pageSize
  state.query = { sortList: [] }
  clearFilter()
  onCancelSelect()
  state.interfaceURL && executeServer(state, props)
  emits('reset')
}
// 重置列条件信息
const resetColumnFilter = column => {
  column.filterValue = []
  column.indeterminate = false
  column.checkAll = false
  column.desc = ''
  column.filtered = false
  column.searchValue = null
  column.isBatch = false
  column.isBlank = false
  if (column.params) {
    column.params.queryStr = ''
  }
  column.batchTags = []
}
const updateColumnField = column => {
  const key = column.key
  if (state.query[key]) {
    column.filtered = true
    column.filterValue = state.query[key]
    state.uid++
  }
}
const clearFilter = () => {
  state.uid++
  state.tableColumns.forEach(column => {
    resetColumnFilter(column)
  })
}
// 取消复选框
const onCancelSelect = () => {
  state.selectedRowKeys = []
  state.currentPageRowKeys = {}
  emits('change', state.selectedRowKeys, [], state.tableDatas)
}
const onSelectChange = (selectedRowKeys, selectedRows) => {
  // this.$set(this.currentPageRowKeys, this.pageNum, selectedRowKeys)
  if (props.rowType === 'radio') {
    state.currentPageRowKeys = {
      [state.pageNum]: selectedRowKeys
    }
    state.pageRows = { [state.pageNum]: selectedRows }
    return
  }
  state.currentPageRowKeys[state.pageNum] = selectedRowKeys
  state.pageRows[state.pageNum] = selectedRows
}
const onSelect = (record, selected) => {
  const index = state.tableDatas.findIndex(column => {
    return column.id === record.id
  })
  state.tableDatas[index].selected = selected

  emits('select', record, selected)
}

// 刷新只刷新当前页，保留用户操作的记录
const refresh = apiParams => {
  if (
    apiParams &&
    Object.prototype.toString.call(apiParams) === '[object Object]'
  ) {
    state.localApiParams = apiParams
  }
  state.interfaceURL && executeSearch(state, props)
  onCancelSelect()
  emits('refresh')
}
const refreshColumn = () => {
  console.log(props, 'props')
  state.tableColumns = []
  config_list_menu_field_post_(props, state)
  executeSearch(state, props)
}

const getPathName = () => {
  const query = window.location.href.split('?')[1]
  const search = query ? `?${query}` : ''
  const url = window.location.hash
    ? window.location.hash.slice(2)
    : window.location.hash.slice(1)
  return url.replace(search, '').replace(/\//g, '_')
}
/**
 * 本地保存用户拖拽的列宽
 */
const setColumnWidth = () => {
  const pathname = getPathName()
  const columnWidths = localStorage.getItem('dragWidth')
  if (columnWidths) {
    state.columnWidth = JSON.parse(columnWidths)[pathname]
      ? JSON.parse(columnWidths)[pathname][state.tableId]
      : props.columnWidth
  }
}
const setQueryParams = val => {
  Object.assign(state.query, val)
  state.tableColumns.forEach(column => {
    updateColumnField(column)
  })
}
// 导出
const exportExcel = () => {
  exportLoading.value = true
  emits(
    'exportExcel',
    {
      ...props.apiParams,
      ...state.query
    },
    {
      pageNum: state.pageNum,
      pageSize: state.pageSize
    }
  )
  setTimeout(() => {
    exportLoading.value = false
  }, 1000)
}
// 获取接口所有参数
const queryAllParams = () => {
  return {
    ...props.apiParams,
    ...state.query,
    pageNum: state.pageNum,
    pageSize: state.pageSize
  }
}

const scrollY = computed(() => {
  const mql = window.matchMedia('(max-width: 1400px)')
  if (mql.matches) {
    return (props.sy || state.sy || 590) - (props.hasFooter ? 50 : 0)
  }
  return (props.y || state.y) - (props.hasFooter ? 50 : 0)
})
const myRowSelection = computed(() => {
  const { pageNum } = state
  const { rowType } = props
  if (props.showSelection) {
    const selectedRowKeys =
      state.currentPageRowKeys[pageNum] || props.selectRowKeys
    return {
      columnWidth: 40,
      fixed: 'left',
      selectedRowKeys,
      type: rowType,
      onChange: onSelectChange,
      onSelect: onSelect,
      getCheckboxProps: props.getCheckboxProps
    }
  }
  return null
})

// 双向绑定当前页的表格数据
watch(
  () => state.tableDatas,
  val => {
    emits('update:value', val)
  },
  {
    deep: true
  }
)
watch(
  () => props.value,
  val => {
    state.tableDatas = val || []
  },
  {
    immediate: true,
    deep: true
  }
)
watch(
  () => props.columns,
  val => {
    val && state.createColumns(val)
  },
  {
    immediate: true,
    deep: true
  }
)
watch(
  () => props.apiParams,
  val => {
    if (
      JSON.stringify(val) !== JSON.stringify(state.localApiParams) &&
      props.isWatchApiParams
    ) {
      state.localApiParams = JSON.parse(JSON.stringify(val))
      changePage(1, state.pageSize)
    }
  },
  {
    deep: true,
    immediate: true
  }
)

watch(
  () => state.currentPageRowKeys,
  val => {
    state.selectedRowKeys = []
    state.selectedRows = []
    const keys = Object.keys(val)
    if (keys.length) {
      keys.map(column => {
        state.selectedRowKeys = [...state.selectedRowKeys, ...val[column]]
        state.selectedRows = [...state.selectedRows, ...state.pageRows[column]]
        emits(
          'change',
          state.selectedRowKeys,
          state.selectedRows,
          state.tableDatas
        )
      })
    } else {
      emits('change', [], [])
    }
  },
  {
    deep: true
  }
)
/**
 * 计算表格的高度
 */
const observeTableHeight = () => {
  if (props.isAddBaseTableHeight) {
    state.yy = tableContainerRef.value.clientHeight - 40 + 'px'
  } else {
    const boxHeight = document.body.offsetHeight
    const node = tableDom.value?.$el
    nextTick(() => {
      node &&
        observeDomResize(node, () => {
          const { top = 0 } = node?.getBoundingClientRect() || {}
          state.yy = Math.max(boxHeight - top - 130, scrollY.value)
        })
    })
  }
}
onMounted(() => {
  useInitState(props, state)
  if (props.canChangeColumnWidth) {
    setColumnWidth()
  }
  if (!props.columns?.length) {
    config_list_menu_field_post_(props, state)
  }
  console.log(state.tableColumns)
  props.immediate && executeServer(state, props)
  nextTick(() => {
    observeTableHeight()
  })
  window.onresize = () => {
    observeTableHeight()
  }
})

defineExpose({
  queryTableData: () => {
    executeServer(state, props)
  },
  changePage,
  onCancelSelect,
  menuListFields: state.menuListFields,
  // updateTableColumn,
  getTableColumns: () => {
    return state.menuListFields
  },
  reset,
  refresh,
  setQueryParams,
  refreshColumn,
  queryAllParams
})
</script>

<style lang="scss" scoped>
:deep(.portal-ant-table-title) {
  display: none;
}
.rm-popover {
  width: 300px;
  max-height: 400px;
  min-height: 200px;
  overflow-y: auto;
}
:deep(.portal-ant-table) {
  &.portal-ant-table-small {
    .portal-ant-table-selection-column {
      padding: 4px !important;
      width: 30px;
      min-width: 30px;
    }
  }
  tr {
    .portal-ant-checkbox-wrapper {
      text-indent: unset;
    }
    th {
      font-size: 12px;
    }
    td {
      padding: 4px 8px !important;
      font-size: 12px;
      button {
        font-size: 12px !important;
      }
      .portal-ant-select-selector {
        text-align: left;
        // border: none !important;
        max-height: 30px !important;
        // line-height: 30px !important;
        height: 100% !important;
        .portal-ant-select-selection-search-input {
          height: 100% !important;
        }
      }
      .portal-ant-btn-link {
        height: 22px;
        padding: 0;
        padding-right: 8px;
      }
    }
  }
}
</style>
<style>
.search-wrap .checkbox-wrap {
  margin-top: 6px;
}
.search-wrap .portal-ant-checkbox-group {
  margin-bottom: 10px;
  min-height: 40px;
  max-height: 200px;
  overflow-y: scroll;
  width: 220px;
}

.search-wrap .portal-ant-checkbox-group .portal-ant-checkbox-wrapper {
  word-break: break-all;
  font-size: 12px;
  display: flex;
}

.search-wrap .portal-ant-checkbox-group .portal-ant-checkbox {
  margin-top: 3px;
  height: 16px;
}

.portal-ant-table-footer {
  padding: 8px 4px;
}

.tableEmpty .portal-ant-table-empty .portal-ant-table-tbody {
  height: 208px;
}

.tableEmpty .portal-ant-table-empty .portal-ant-table-placeholder {
  position: absolute;
  width: 100%;
  top: 51px;
  z-index: 5;
}
</style>
